import appConfig from '../../../config/appConfig';

var reportsConfig = {
  bdeBuchungenUrl: appConfig.apiUrl + 'reports/bde_buchungen',
  timeparkUrl: appConfig.apiUrl + 'download/timepark'
};

export default reportsConfig;



// WEBPACK FOOTER //
// ./src/components/reports/config/reportsConfig.js